import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Stage, Layer } from "react-konva";
import { Provider } from "react-redux";
import { ImagenSonda } from "./ImageContext";
import { resizeWindow,setModoTransductor, abrirVideo, updateDataUser, cargaAbordaje } from "../js/actions/index";
import Transductor from "./Transductor";
import Slider from "./HSlider";
import store from "../js/store/index";
import caso from "../caso";
import "./anatomia.scss";

const mapStateToProps = state => {
	let gelVisto = (state.login.user && state.login.user.acf && state.login.user.acf.gel_visto)?state.login.user.acf.gel_visto:false;
	let ultima_exploracion = (state.login.user && state.login.user.acf && state.login.user.acf.ultima_exploracion)?parseInt(state.login.user.acf.ultima_exploracion):0;
	let soloAtlas = (state.login.user.acf && state.login.user.acf.solo_atlas)?state.login.user.acf.solo_atlas:false;
	return { 
		gelVisto: gelVisto,
		anatomia: state.anatomia,
		exploracion: state.exploracion,
		ultima_exploracion: ultima_exploracion,
		soloAtlas: soloAtlas,
	};
};

function mapDispatchToProps(dispatch) {
	return {
		resize: (size) => dispatch(resizeWindow(size)),
		setModo: (modo) => dispatch(setModoTransductor(modo)),
		abrirGel: () => dispatch(abrirVideo("gel")),
		abrirTutor: () => dispatch(abrirVideo("tutorial")),
		updateDataUser:(field,value)=>dispatch(updateDataUser({field,value})),
		cargaAbordaje: (caso,abordaje)=> dispatch(cargaAbordaje({caso,abordaje})),
	};
}
class AnatomiaConected extends Component {
	static propTypes = {
		exploracion: PropTypes.object,
		ultima_exploracion: PropTypes.number,
		anatomia: PropTypes.object,
		resize: PropTypes.func,
		setModo: PropTypes.func,
		abrirGel: PropTypes.func,
		abrirTutor: PropTypes.func,
		gelVisto:PropTypes.bool,
		updateDataUser:PropTypes.func,
		cargaAbordaje:PropTypes.func,
		soloAtlas: PropTypes.bool,
	}

	componentDidMount(){
		this.checkSize();
		window.addEventListener("resize", this.checkSize);
	}
	
	componentWillUnmount() {
		window.removeEventListener("resize", this.checkSize);
	}

	checkSize = () => {
		if(this.container !== null &&
			(this.props.anatomia.size.width !== this.container.offsetWidth || this.props.anatomia.size.height !== this.container.offsetHeight)
		){
			this.props.resize({
				width: this.container.offsetWidth,
				height: this.container.offsetHeight,
			});
		}
	};
	
	btnModo = (modo) =>{
		let clase = "iconoTransductor";
		let active = false;
		if(this.props.anatomia.siguienteModo === modo){
			clase += " active";
			active = true;
		}
		else if(this.props.anatomia.modo === modo) clase += " on";
		return(<div className={clase} id={modo} onClick={() =>  {
			if(active){
				if(!this.props.gelVisto)
					alert("Antes debería aplicar gel.");
				else if(this.props.anatomia.recorridoActual > -1 && !this.props.anatomia.terminado)
					alert("Debe identificar todos los atlas antes de continuar.");
				else {
					this.props.setModo(modo);
				}
			}}}></div>);
	}

	btnGel = () => {
		let clase = "iconoTransductor on der";
		return(<div className={clase} id="gel" onClick={() =>  {
			if(!this.props.gelVisto){
				this.props.updateDataUser("gel_visto",true);
				this.props.abrirGel();
			}
		}}></div>);
	}

	siguiente= ()=>{
		let numExploracion = 0;
		for(let i = 0; i< this.props.exploracion.casoActual; i++)
			numExploracion += caso[i].abordajes.length;
		let casoActual = caso[this.props.exploracion.casoActual];
		if(this.props.exploracion.abordajeActual < casoActual.abordajes.length-1){
			let nuevoAbordaje = this.props.exploracion.abordajeActual+1;
			numExploracion += nuevoAbordaje;
			this.props.cargaAbordaje(this.props.exploracion.casoActual,nuevoAbordaje);
		}else if (this.props.exploracion.casoActual < caso.length-1){
			numExploracion += casoActual.abordajes.length;
			this.props.cargaAbordaje(this.props.exploracion.casoActual + 1,0);
		}else{
			if(!this.props.soloAtlas) alert("Ha terminado el curso, ya puede realizar el examen final.");
			else alert("No hay mas ejercicios.");
			numExploracion += casoActual.abordajes.length +1;
		}if(numExploracion > this.props.ultima_exploracion){
			this.props.updateDataUser("ultima_exploracion",numExploracion);
		}
	}
  
	render () {
		let color = "#FF0000";
		let slider = null;
		if(this.props.anatomia.distancia < 0.005) color = "#00FF00";
		else if (this.props.anatomia.distancia < 0.025){
			color = "rgb("+Math.round((this.props.anatomia.distancia*40)*255)+",200,0)";
		}else if (this.props.anatomia.distancia < 0.05){
			color = "rgb(255,"+Math.round((0.05 - this.props.anatomia.distancia)*8000)+",0)";
		}else  color = "#FF0000";
		let numFondo = 0;
		if(this.props.anatomia.recorridoActual >= 0){
			let recorrido = caso[this.props.exploracion.casoActual].abordajes[this.props.exploracion.abordajeActual].recorrido[this.props.anatomia.recorridoActual];
			if(recorrido && recorrido.tipo === "din"){
				let tipo = "V";
				if (!recorrido.mod || recorrido.mod !== "V"){
					tipo = "H";
					numFondo = Math.round((this.context.fondo.length-1) * this.props.anatomia.porcentaje);
				}
				slider=<Slider tipo={tipo}/>;
			}
		}
		let fondo = this.context.fondo[numFondo];
		let semaforoStyle = {backgroundColor:color};
		if(this.props.anatomia.recorridoActual === caso[this.props.exploracion.casoActual].abordajes[this.props.exploracion.abordajeActual].recorrido.length-1)
			semaforoStyle["display"]="none";
		let clase = "btnSiguiente";
		if(this.props.anatomia.terminado && this.props.anatomia.recorridoActual === caso[this.props.exploracion.casoActual].abordajes[this.props.exploracion.abordajeActual].recorrido.length-1 ) clase += " on";
		let leyenda = null;
		if(caso[this.props.exploracion.casoActual].abordajes[this.props.exploracion.abordajeActual].recorrido.length > 1)
			leyenda = <p>El recorrido tiene varias partes, deberá localizar los atlas de todas antes de pasar al siguiente abordaje.</p>;
		else if(caso[this.props.exploracion.casoActual].abordajes[this.props.exploracion.abordajeActual].recorrido[0].tipo === "din")
			leyenda = <p>El ejercicio es un test dinámico, situe la sonda en la zona a explorar para activar el movimiento y realícelo utilizando el slider de la imagen.</p>;
		let siguiente = <><button className={clase} onClick={this.siguiente}>Siguiente ejercicio</button>{leyenda}</>;
		return(
		<>
			<aside id="botoneraTransductores">
				{this.btnModo("mov")}
				{/*this.btnModo("basc")*/}
				{this.btnModo("giro")}
				{this.btnModo("din")}
				{this.props.gelVisto?siguiente:this.btnGel()}
			</aside>
			<section id="anatomiaExterna">
				{this.props.anatomia.terminado}
				<div id="semaforo" style={semaforoStyle}></div>
				<div id="imagen" ref={node => {this.container = node;}}>
					<img alt="fondo" src={fondo.src}/>
					<div className="btnTutorial" id="tutorial" onClick={() =>  {this.props.abrirTutor();}}>Tutorial</div>
					{slider}
					<Stage width={this.props.anatomia.size.width} height={this.props.anatomia.size.height}>
						<Layer>
							<ImagenSonda.Provider value={this.context.sonda}>
								<Provider store={store}>
									<Transductor/>
								</Provider>
							</ImagenSonda.Provider>
						</Layer>
					</Stage>
				</div>
			</section>
		</>
		);
	}
}
AnatomiaConected.contextType = ImagenSonda;

export default connect(mapStateToProps,mapDispatchToProps)(AnatomiaConected);